import axios from 'axios';
import {jwtDecode} from 'jwt-decode';
import { normalizePermissions } from './auth/permissionUtils';

// Tworzymy oddzielną instancję do odświeżania tokena (bez interceptora)
const refreshInstance = axios.create();
const API_URL = process.env.REACT_APP_API_URL;
// Interceptor request – dodajemy logi do debugowania
axios.interceptors.request.use(async (config) => {
  if (!config.url) return config;
  if (config.url.includes('/refresh') || config.url.includes('/logowanie')) {
    console.log("Interceptor: Pomijam logikę tokena dla endpointu publicznego");
    return config;
  }

  const token = localStorage.getItem('token');
  if (token) {
    console.log("Interceptor: Odczytany token z localStorage:", token);
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      // Jeśli token wygasa za mniej niż 10 minut (600 sekund)
      if (decoded.exp - currentTime < 600) {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
          return config;
        }
        const response = await refreshInstance.post(`${API_URL}/refresh`, { refreshToken });
        if (response && response.data && response.data.accessToken) {
          const newToken = response.data.accessToken;
          localStorage.setItem('token', newToken);
          try {
            const decodedNew = jwtDecode(newToken);
            const storedUser = JSON.parse(localStorage.getItem('uzytkownik') || 'null');
            const permissions = Array.isArray(decodedNew.permissions)
              ? decodedNew.permissions
              : normalizePermissions(storedUser || {});

            if (storedUser) {
              localStorage.setItem('uzytkownik', JSON.stringify({ ...storedUser, permissions }));
            }
            localStorage.setItem('permissions', JSON.stringify(permissions));
          } catch (_e) {}
          config.headers.Authorization = `Bearer ${newToken}`;
        } else {
          console.error("Interceptor: Endpoint /refresh nie zwrócił poprawnego accessTokena");
        }
      } else {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (err) {
      console.error("Interceptor: Błąd podczas przetwarzania tokena:", err);
    }
  } else {
    console.log("Interceptor: Brak tokena w localStorage");
  }
  return config;
});
